import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { ProductPage } from "./pages/ProductPage";
import { QRPage } from "./pages/QRPage";
import "./index.css";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/:gtin/qr" element={<QRPage />} />
        <Route path="/:gtin" element={<ProductPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
